import { ANSWER_QUESTION_ERROR, ANSWER_QUESTION_SUCCESS, IS_ANSWERING_QUESTION, RESET_ANSWER_STATE } from "../actions/action_types";

export default function answerReducer(state = { isAnswering: false, answerSubmitSuccess: false, ansswerSubmitError: null }, action) {
    switch (action.type) {
        case IS_ANSWERING_QUESTION:
            return {...state, isAnswering: true }
        case ANSWER_QUESTION_SUCCESS:
            return {...state, isAnswering: false, answerSubmitSuccess: true }
        case ANSWER_QUESTION_ERROR:
            return {...state, isAnswering: false, answerSubmitError: action.payload }
        case RESET_ANSWER_STATE:
            return { isAnswering: false, answerSubmitSuccess: false, ansswerSubmitError: null }
        default:
            return state
    }
}